// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"excelButton__btnContainer___UtJbX","excelIcon":"excelButton__excelIcon___94il0"};